/** @format */

import { Col, Card, Button } from "react-bootstrap";
import ExperienceForm from "./experience-form";
import { useState } from "react";
import {
  useGetUserExperiences,
  useGetUserExperiencesByUserID,
  useGetUserMe,
} from "../../../../../../api/queries/user.query";

const Experience = () => {
  const [isOpen, setOpen] = useState(false);
  const handleToggleSection = () => {
    setOpen(!isOpen);
    console.log("isOpen", !isOpen); // Log updated state
  };

  const { data: userData, isLoading: isLoadingUserData } = useGetUserMe({
    select: (response) => response.data.user,
  });
  console.log(userData?.id);

  const { data: ExperienceData, isLoading: isLoadingExperienceData } =
    useGetUserExperiencesByUserID({
      select: (data) => data.data.experiences,
      enable: !!userData?.id,
      param: {
        user_id: userData?.id,
      },
    });

  return (
    <Col lg="12">
      <Card>
        <div className="w-full text-end">
          <Button
            variant="success"
            type="button"
            className="btn btn-success mt-4 fw-semibold text-uppercase d-flex align-items-center ms-auto"
            onClick={handleToggleSection}
          >
            <span className="material-symbols-outlined">add</span>
            Add New Working Experience
          </Button>
        </div>
        <div
          style={{
            maxHeight: isOpen ? "800px" : "0",
            opacity: isOpen ? 1 : 0,
            overflow: "hidden",
            transition: "all 300ms ease-in-out",
          }}
        >
          <ExperienceForm />
        </div>
        <Card.Header className="d-flex justify-content-between">
          <div className="header-title">
            <h4 className="card-title text-xl">Working Experiences</h4>
          </div>
        </Card.Header>
        {isLoadingExperienceData ? (
          <p>Loading...</p>
        ) : userData && userData.experiences ? (
          userData.experiences.map((experience) => (
            <Card.Body key={experience.id} className="p-0">
              <ul className="iq-timeline my-0">
                <li className="d-flex">
                  {/* Timeline Dot */}
                  <div
                    className="timeline-dots bg-success me-3"
                    style={{
                      width: "10px",
                      height: "10px",
                      borderRadius: "50%",
                    }}
                  ></div>

                  {/* Content Section */}
                  <div className="w-100">
                    {/* Title and Date */}
                    <div className="d-flex align-items-center justify-content-start">
                      <h6 className="mb-1">{experience.title}</h6>
                      <span
                        className="px-2 py-1 ms-4"
                        style={{
                          backgroundColor: "#E0F7FA", // Light blue background for date
                          borderRadius: "20px",
                          fontSize: "0.9rem",
                        }}
                      >
                        {new Date(experience.start_date).toLocaleDateString(
                          "en-US",
                          {
                            year: "numeric",
                            month: "short",
                          }
                        )}
                        -
                        {new Date(experience.end_date).toLocaleDateString(
                          "en-US",
                          {
                            year: "numeric",
                            month: "short",
                          }
                        )}
                      </span>
                      {/* Icons (Edit and Delete) */}
                      <div className="ms-auto">
                        <button className="btn btn-icon text-success me-2 bg-success-subtle">
                          <i className="material-symbols-outlined">edit</i>
                        </button>
                        <button className="btn btn-icon text-danger bg-danger-subtle">
                          <i className="material-symbols-outlined">delete</i>
                        </button>
                      </div>
                    </div>

                    {/* Subheading (Company Name and GPA) */}
                    <div className="d-flex align-items-center mb-2">
                      <a
                        href="#"
                        className="text-primary me-2"
                        style={{
                          fontSize: "1rem",
                        }}
                      >
                        {experience.company_string}
                      </a>
                    </div>

                    {/* Description */}
                    <p className="text-muted">{experience.description}</p>
                  </div>
                </li>
              </ul>
            </Card.Body>
          ))
        ) : (
          <Card.Body className="pt-0">
            <ul className="iq-timeline ms-1">
              <li>
                <div className="timeline-dots border-success"></div>
                <div className="d-flex align-items-center justify-content-between">
                  <h6 className="mb-1">No Experience!</h6>
                </div>
              </li>
            </ul>
          </Card.Body>
        )}
      </Card>
    </Col>
  );
};

export default Experience;
